import Config from '@/configs/lending';

const ROUTE_CONFIG = {
  dolomite: {
    type: 'lending',
    theme: {
      '--button-color': '#68B04D',
      '--switch-color': '#68B04D',
      '--button-text-color': '#FFFFFF',
      '--supply-color': '#68B04D',
      '--yours-table-title': '#FFFFFF',
      '--borrow-color': '#FFFFFF',
      '--withdraw-bg-color': '#68B04D',
      '--withdraw-border-color': '#68B04D',
      '--withdraw-bg-hover-color': '#68B04D',
      '--repay-bg-color': '#68B04D',
      '--repay-border-color': '#68B04D',
      '--repay-bg-hover-color': '#68B04D',
      '--claim-bg-hover-color': '#68B04D',
      '--claim-bg-color': '#68B04D',
      '--claim-border-color': '#68B04D',
      '--withdraw-color': '#FFFFFF',
      '--replay-color': '#FFFFFF',
      '--claim-color': '#FFFFFF'
    },
    icon: '/images/dapps/dolomite.svg',
    config: Config.Dolomite,
  },
  bend: {
    type: 'lending',
    theme: {
      '--button-color': '#EAEBEF',
      '--button-disabled-color': 'rgba(234, 235, 239, .7)',
      '--switch-color': '#45499F',
      '--button-text-color': 'black',
      '--supply-color': '#EAEBEF',
      '--yours-table-title': 'black',
      '--borrow-color': '#EAEBEF',
      '--withdraw-bg-color': '#EAEBEF',
      '--withdraw-border-color': '#EAEBEF',
      '--withdraw-bg-hover-color': '#EAEBEF',
      '--repay-bg-color': '#EAEBEF',
      '--repay-border-color': '#EAEBEF',
      '--repay-bg-hover-color': '#EAEBEF',
      '--claim-bg-hover-color': '#EAEBEF',
      '--claim-bg-color': '#EAEBEF',
      '--claim-border-color': '#EAEBEF',
      '--withdraw-color': '#EAEBEF',
      '--replay-color': '#EAEBEF',
      '--claim-color': '#EAEBEF'
    },
    icon: '/images/dapps/bend.svg',
    config: Config.Bend,
  },
  beraborrow: {
    type: 'lending',
    theme: {
      '--button-color': '#EAEBEF',
      '--button-disabled-color': 'rgba(234, 235, 239, .7)',
      '--switch-color': '#45499F',
      '--button-text-color': 'black',
      '--supply-color': '#EAEBEF',
      '--yours-table-title': 'black',
      '--borrow-color': '#EAEBEF',
      '--withdraw-bg-color': '#EAEBEF',
      '--withdraw-border-color': '#EAEBEF',
      '--withdraw-bg-hover-color': '#EAEBEF',
      '--repay-bg-color': '#EAEBEF',
      '--repay-border-color': '#EAEBEF',
      '--repay-bg-hover-color': '#EAEBEF',
      '--claim-bg-hover-color': '#EAEBEF',
      '--claim-bg-color': '#EAEBEF',
      '--claim-border-color': '#EAEBEF',
      '--withdraw-color': '#EAEBEF',
      '--replay-color': '#EAEBEF',
      '--claim-color': '#EAEBEF'
    },
    icon: '/images/dapps/beraborrow.png',
    config: Config.Beraborrow,
  }
};

export default ROUTE_CONFIG;
